<div #itemElement
    [id]="id"
    class="agpr-contentLibraryItem"
    [ngClass]="{ 'agpr-contentLibraryItem-focused': isCurrentlySelected }"
    tabindex="0"
    role="button"
    (agprClickUnless)="onClick()"
    [agprClickUnlessSelectors]="['agpr-checkbox', 'agpr-radio']">

    @if (showCheckbox) {
        @if (singleSelect) {
            <agpr-radio
                [id]="id + '_select'"
                class="agpr-contentLibraryItem-checkbox"
                [value]="item"
                [(ngModel)]="isSelected"
                [ariaLabel]="'Select ' + item.name"
                (ngModelChange)="onCheckboxClick($event)"
            >
            </agpr-radio>
        } @else {
            <agpr-checkbox
                [id]="id + '_select'"
                class="agpr-contentLibraryItem-checkbox"
                [value]="item"
                [(ngModel)]="isSelected"
                [ariaLabel]="'Select ' + item.name"
                (ngModelChange)="onCheckboxClick($event)"
                [binary]="true">
            </agpr-checkbox>
        }
    }
    <div
        [id]="id + '_thumbnail'"
        class="agpr-contentLibraryItem-thumbnail-container"
    >

        @if ((item.url && (item.mimeType === 'image/png' || item.mimeType === 'image/jpeg') && !hasError)) {
            <img
                [id]="id + '_thumbnail_image'"
                [src]="item.url + '?isThumbnail=true'"
                [alt]="item.name"
                class="agpr-contentLibraryItem-thumbnail"
                (error)="hasError = true"
            >
        } @else {
            <span
                [id]="id + '_thumbnail_icon'"
                [ngClass]="['thumbnail-container-default-icon', getFileIcon(item.mimeType)]"
            ></span>
        }
    </div>

    <div
        [id]="id + '_fileInfo'"
        class="agpr-contentLibraryItem-file-info"
    >
        <span
            [id]="id + '_fileName'"
            class="agpr-contentLibraryItem-file-name"
            [agprTooltip]="item.name"
        >
            {{ item.name }}
        </span>
        <span
            [id]="id + '_uploadDate'"
            class="agpr-contentLibraryItem-upload-date"
        >{{ item.createdDate | date:preferences.dateFormat}}</span>
        <span
            [id]="id + '_fileSize'"
            class="agpr-contentLibraryItem-file-size"
        >{{ formatFileSize(item.size) }}</span>
    </div>
    @if (showRemoveButton) {
        <agpr-button
            [id]="id + '_remove'"
            agprTooltip="Common.contentLibrary.unselectFile"
            tooltipPosition="top"
            class="agpr-contentLibraryItem-closeButton"
            icon="fa-regular fa-duotone fa-xmark"
            (click)="unSelect()">
        </agpr-button>
    }
</div>
